<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area vision">
      <img :src="`${resources}img/img-top-sub-title4.jpg`" alt="" />
      <div class="tit_area">
        <div class="sub_tit">VISION</div>
        <div class="sub_txt">
          Smart Innovative Eco-Friendly Construction<br />스마트하고 혁신적이며,
          친환경적인 건설 시장을 열어갑니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <h3 class="h3_tit">기업철학</h3>
      <div class="tit_sub">
        한국오션플랫폼은 장기적이고 전략적인 안목으로 안정적인 건축 사업구조를
        구축했고, 창립 이래 끊임없는 도전과 연구를 통해 새로운 미래를
        창조함으로써 인류사회의 꿈을 실현합니다.
      </div>
      <ul class="vision_list">
        <li>
          <p>스마트한 첨단기술</p>
          <div>
            21세기 최첨단<br />자동생산라인 구축으로<br />미래가치 실현 추구
          </div>
        </li>
        <li>
          <p>지속적 혁신</p>
          <div>
            건설공사의 생산성,<br />안정성, 품질 등을<br />향상시키는 공법 추구
          </div>
        </li>
        <li>
          <p>친환경 경영</p>
          <div>
            건설공사에서 발생하는<br />비산먼지, 부산물 등을<br />최소화해
            친환경 공사 추구
          </div>
        </li>
        <li>
          <p>미래형 건축</p>
          <div>
            건축을 뛰어넘는<br />효율적 공간 창조로<br />미래형 신개념 건축 추구
          </div>
        </li>
      </ul>
    </div>

    <div class="sub_contents bg_gray">
      <h3 class="h3_tit2">핵심가치</h3>
      <div class="tit_sub">
        한국오션플랫폼은 4대 핵심가치를 통해 선진 건축 문화를 구축하며 성공
        DNA를 더욱 발전시켜 나갈 것입니다.
      </div>
      <ul class="vision_list01">
        <li>
          <p>가치창출 <span>Value Creation</span></p>
          <div>
            현재에 안주하지 않고 새로운 가치를 창출하여 더 큰 미래로 나아간다.
          </div>
        </li>
        <li>
          <p>고객지향 <span>Customer Satisfaction</span></p>
          <div>
            고객 입장에서 생각하며 최고의 품질과 서비스로 고객만족을 실현한다.
          </div>
        </li>
        <li>
          <p>협력 <span>Speak Together</span></p>
          <div>동료, 파트너사와 열린 마음으로 소통하고 함께 발전한다.</div>
        </li>
        <li>
          <p>원칙과 기본준수 <span>Rule & Responsibility</span></p>
          <div>원칙과 기본을 지키며 책임은 반드시 완수한다.</div>
        </li>
      </ul>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page]
};
</script>

<style lang="scss" scoped></style>
